var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lista-aste" }, [
    _vm.lista == null
      ? _c(
          "div",
          {
            staticClass: "d-flex justify-center",
            staticStyle: { height: "50px" },
          },
          [
            _c("v-progress-circular", {
              staticClass: "navy--text",
              attrs: { indeterminate: "" },
            }),
          ],
          1
        )
      : _vm.lista && _vm._.size(_vm.lista) > 0
      ? _c(
          "div",
          [
            _c(
              "v-list",
              {
                staticClass: "overflow-y-auto pa-4",
                class: { "nice-scroll": !_vm.is_mobile },
                attrs: { id: "lista" },
              },
              _vm._l(_vm.lista, function (squadraWithAsta, squadra_id) {
                return _c(
                  "v-list-item",
                  { key: squadra_id, staticClass: "list-item con-ombra" },
                  [
                    _c("img", {
                      staticClass: "mr-2",
                      attrs: { src: squadraWithAsta.pic },
                    }),
                    _vm._v(" "),
                    _c(
                      "v-list-item-content",
                      { staticClass: "text-left" },
                      [
                        _c("v-list-item-title", [
                          _c(
                            "div",
                            { staticClass: "font-weight-bold white--text" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(squadraWithAsta.name) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("v-list-item-subtitle", [
                          _vm._v(_vm._s(squadraWithAsta.astaInfo.name)),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item-action",
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "primary",
                            attrs: { depressed: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.gotoAsta(squadraWithAsta.astaInfo.id)
                              },
                            },
                          },
                          [
                            _vm._v("\n            Apri "),
                            _c("v-icon", { attrs: { right: "" } }, [
                              _vm._v("chevron_right"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        )
      : _c("div", { staticClass: "lista-vuota py-4" }, [
          _c("div", { staticClass: "navy--text" }, [
            _c(
              "div",
              [
                _c("v-icon", { staticClass: "navy--text" }, [
                  _vm._v("shield "),
                ]),
                _vm._v(" "),
                _c("v-icon", { staticClass: "navy--text" }, [
                  _vm._v("shield "),
                ]),
                _vm._v(" "),
                _c("v-icon", { staticClass: "navy--text" }, [
                  _vm._v("shield "),
                ]),
                _vm._v(" "),
                _c("v-icon", { staticClass: "navy--text" }, [
                  _vm._v("shield "),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("h3", [_vm._v("Nessuna asta.")]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }